/* eslint-disable @typescript-eslint/no-require-imports */
// export const liffId: string = "2005858407-zQMeeryx";
// 開発環境;
export const liffId: string =
  process.env.NODE_ENV == "development"
    ? "2005858818-8LdxxRaW"
    : "2005858407-zQMeeryx";

// "2005858407-zQMeeryx"; // 本番
// "2005858818-8LdxxRaW"; // local

// BASEURL
export const APIBASEURL =
  process.env.NODE_ENV == "development"
    ? "https://staging.omot-zero.com/api/omi/"
    : "https://omot-zero.com/api/omi/";

// "https://omot-zero.com/api/omi/"; // 本番
// "https://staging.omot-zero.com/api/omi/"; // local

export const BASEURL =
  process.env.NODE_ENV == "development"
    ? "https://staging.omot-zero.com"
    : "https://omot-zero.com";

// "https://omot-zero.com"; // 本番
// "https://staging.omot-zero.com"; // local

// ユーザー
export const USER = "registered";
// ノンユーザー
export const UNUSER = "unregistered";

// 退会済ユーザー
export const WITHDRAWN = "withdrawn";

export const projectname: string =
  process.env.NODE_ENV == "development" ? "omi-liff-dev" : "omi-liff-dev";
// 10件ずつ表示
export const rowsPerPage: number = 10;
/** 案件ステータス */
export const PROJECT_STATE = {
  /** 草稿 */
  DRAFT: 0,
  /** 確認待ち */
  WAITING_FOR_CONFIRMATION: 1,
  /** 公開済み */
  PUBLISHED: 2,
  /** 当選者選定待ち */
  WAITING_FOR_SELECTION: 3,
  /** 投稿待ち */
  WAITING_FOR_POST: 4,
  /** 完了 */
  DONE: 5,
  /** 非公開 */
  REJECTED: 10,
  /** キャンセル */
  CANCELED: 11,
};
/** 案件ステータス名 */
export const PROJECT_STATE_NAME = [
  {
    /** 草稿 */
    state: 0,
    name: " 草稿 ",
  },
  {
    /** 確認待ち */
    state: 1,
    name: " 確認待ち ",
  },
  /** 公開済み */
  { state: 2, name: " 公開済 " },
  /** 当選者選定待ち */
  { state: 3, name: " 当選者選定待ち " },
  /** 投稿待ち */
  { state: 4, name: " 投稿待ち " },
  /** 完了 */
  { state: 5, name: " 完了 " },
  /** 非公開 */
  { state: 10, name: " 非公開 " },
  /** キャンセル */
  { state: 11, name: " キャンセル " },
];
/** ユーザー応募ステータス */
export const APPLICATION_STATE = {
  /** 応募前 0*/
  BEFORE_APPLY: 0,
  /** 応募済 1*/
  APPLIED: 1,
  /** 当選済 2*/
  WON: 2,
  /** 商品送付待 3 */
  WAITING_FOR_ITEM: 3,
  /** 下書き送信待 4*/
  WRITING_DRAFT: 4,
  /** 下書き確認中 5*/
  CHECK_DRAFT: 5,
  /** 投稿待ち 6 */
  BEFORE_POST: 6,
  /** 投稿確認中 7*/
  CHECKING_POST: 7,
  /** 報酬支払い待 8*/
  WAITING_FOR_PAID: 8,
  /** 完了 9*/
  DONE: 9,
  /** 落選 10*/
  REJECTED: 10,
  /** キャンセル 11 */
  CANCELED: 11,
  /** 応募不可 12*/
  CANNOT_APPLY: 12,
};
/** ユーザーSNSアカウントステータス */
export const USER_SNS_REVIEW_STATE = {
  /** 審査前 */
  BEFORE_REVIEW: 0,
  /** 合格 */
  PASSED: 1,
  /** 不合格 */
  REJECTED: 2,
};
/** 応募済一覧タブ */
export const APPLIED_TAB_LIST = new Map()
  .set(1, { name: "応募中案件", state: [1] })
  .set(2, { name: "進行中案件", state: [2, 3, 4, 5, 6, 7] })
  .set(3, { name: " 完了案件 ", state: [8, 9, 10, 11] });

/** 応募済一覧タブ 既読 */
export const APPLIED_TAB_READ_STATUS = new Map()
  .set(1, "applied")
  .set(2, "progress")
  .set(3, "completed");

/** データなし map */
export const NO_DATA = new Map()
  .set(1, { img: require("../assets/no-applied-data.svg") })
  .set(2, { img: require("../assets/no-progress-data.svg") })
  .set(3, { img: require("../assets/no-done-data.svg") })
  .set(4, { img: require("../assets/no-favorite-data.svg") })
  .set(5, { img: require("../assets/no-document-data.svg") });

/** ユーザー応募ステータス */
export const APPLICATION_STATE_NAME = [
  {
    /** 応募前 */
    state: APPLICATION_STATE.BEFORE_APPLY,
    name: "応募前",
  },
  {
    /** 応募済み */
    state: APPLICATION_STATE.APPLIED,
    name: "応募済",
  },
  /** 当選済み */
  { state: APPLICATION_STATE.WON, name: "当選済" },
  /** 商品送付待ち */
  { state: APPLICATION_STATE.WAITING_FOR_ITEM, name: "商品送付待" },
  /** 下書き送信待ち */
  { state: APPLICATION_STATE.WRITING_DRAFT, name: "下書き送信待 " },
  /** 下書き確認中 */
  { state: APPLICATION_STATE.CHECK_DRAFT, name: "下書き確認中" },
  /** 投稿待 */
  { state: APPLICATION_STATE.BEFORE_POST, name: "投稿待" },
  /** 投稿確認中 */
  { state: APPLICATION_STATE.CHECKING_POST, name: "投稿確認中" },
  /** 報酬支払い待ち */
  { state: APPLICATION_STATE.WAITING_FOR_PAID, name: "報酬支払い待" },
  /** 完了 */
  { state: APPLICATION_STATE.DONE, name: "完了" },
  /** 落選 */
  { state: APPLICATION_STATE.REJECTED, name: "落選" },
  /** キャンセル */
  { state: APPLICATION_STATE.CANCELED, name: "キャンセル" },
  /** 応募不可 */
  { state: APPLICATION_STATE.CANNOT_APPLY, name: "応募不可" },
];
/** MEDIA_TYPE */
export const MEDIA_TYPE = {
  /** Instagram */
  INSTAGRAM: 0,
  /** tiktok */
  TIKTOK: 1,
  /** youtube */
  YOUTUBE: 2,
  /** x */
  X: 3,
};
/** SNSアイコン */
export const MEDIA_ICON = [
  require("../assets/instagram.svg"),
  require("../assets/tiktok.svg"),
  require("../assets/youtube.svg"),
  require("../assets/x.svg"),
];
/** SNS名 */
export const MEDIA_NAME = ["Instagram", "Tiktok", "Youtube", "X"];

export const APPLICATION_STATE_BUTTON = new Map();

export const MEDIA_LINK = [
  "https://instagram.com/",
  "https://www.tiktok.com/",
  "https://youtube.com/",
  "https://x.com/",
];

/** toastアイコン */
export const TOAST_ICON = [
  require("../assets/banner-success.svg"),
  require("../assets/banner-fail.svg"),
  require("../assets/information.svg"),
];

export const BUTTON_NAME = new Map()
  .set(APPLICATION_STATE.BEFORE_APPLY, { status: 0, button: "応募する" })
  .set(APPLICATION_STATE.CANCELED, { status: 0, button: "再応募する" })
  .set(APPLICATION_STATE.CANNOT_APPLY, { status: 2, button: "応募不可" });

/** 応募した案件の進行ステータス */
export const PROJECT_STATUS = new Map()
  .set(APPLICATION_STATE.APPLIED, {
    index: APPLICATION_STATE.APPLIED,
    title: "案件応募済",
    message: "案件への応募を受け付けました\r\n抽選までしばらくお待ちください",
    button: "応募を取り消す",
  })
  .set(APPLICATION_STATE.WON, {
    index: APPLICATION_STATE.WON,
    title: "案件当選",
    message: "案件に当選しました!\r\n事務局からの連絡をお待ちください",
    button: "",
  })
  .set(APPLICATION_STATE.WAITING_FOR_ITEM, {
    index: APPLICATION_STATE.WAITING_FOR_ITEM,
    title: "商品送付",
    message: "商品を配送中です\r\n到着までしばらくお待ちください",
    button: "商品を受け取りました",
  })
  .set(APPLICATION_STATE.WRITING_DRAFT, {
    index: APPLICATION_STATE.WRITING_DRAFT,
    title: "下書き入力",
    message: "案件詳細に記載されている内容を元に下書きを入力します",
    button: "下書きを入力する",
  })
  .set(APPLICATION_STATE.CHECK_DRAFT, {
    index: APPLICATION_STATE.CHECK_DRAFT,
    title: "下書き確認",
    message: "事務局側で下書きを確認中です\r\n完了までしばらくお待ちください",
    button: "",
  })
  .set(APPLICATION_STATE.BEFORE_POST, {
    index: APPLICATION_STATE.BEFORE_POST,
    title: "投稿",
    message: "記載頂いた下書きの投稿をお願い致します",
    greyButton: "下書きの内容をコピーする",
    button: "投稿が完了しました",
  })
  .set(APPLICATION_STATE.CHECKING_POST, {
    index: APPLICATION_STATE.CHECKING_POST,
    title: "投稿確認",
    message:
      "事務局で投稿頂いた内容を確認中です\r\n完了までしばらくお待ちください",
    button: "",
  })
  .set(APPLICATION_STATE.WAITING_FOR_PAID, {
    index: APPLICATION_STATE.WAITING_FOR_PAID,
    title: "報酬支払",
    message:
      "事務局側で投稿が確認できました\r\n報酬のお支払いまでしばらくお待ちください",
    greyButton: "振込先銀行口座を確認する",
  })
  .set(APPLICATION_STATE.DONE, {
    index: APPLICATION_STATE.DONE,
    title: "完了",
    message: "案件が完了しました\r\n次回の応募をお待ちしております",
    greyButton: "他の募集案件を探す",
  })
  .set(APPLICATION_STATE.REJECTED, {
    index: APPLICATION_STATE.REJECTED,
    title: "落選",
    message: "残念ながら案件に落選しました\r\nまたの応募をお待ちしております",
    greyButton: "他の募集案件を探す",
  })
  .set(APPLICATION_STATE.CANCELED, {
    index: APPLICATION_STATE.CANCELED,
    title: "取り消し",
    message:
      "案件への応募を取り消しました\r\n再応募を希望する場合は下記より応募してください",
    button: "再度応募する",
  });
// 都道府県
export const PREFECTURE = new Map()
  .set(null, "")
  .set("北海道", "北海道")
  .set("青森県", "青森県")
  .set("岩手県", "岩手県")
  .set("宮城県", "宮城県")
  .set("秋田県", "秋田県")
  .set("山形県", "山形県")
  .set("福島県", "福島県")
  .set("茨城県", "茨城県")
  .set("栃木県", "栃木県")
  .set("群馬県", "群馬県")
  .set("埼玉県", "埼玉県")
  .set("千葉県", "千葉県")
  .set("東京都", "東京都")
  .set("神奈川県", "神奈川県")
  .set("新潟県", "新潟県")
  .set("富山県", "富山県")
  .set("石川県", "石川県")
  .set("福井県", "福井県")
  .set("山梨県", "山梨県")
  .set("長野県", "長野県")
  .set("岐阜県", "岐阜県")
  .set("静岡県", "静岡県")
  .set("愛知県", "愛知県")
  .set("三重県", "三重県")
  .set("滋賀県", "滋賀県")
  .set("京都府", "京都府")
  .set("大阪府", "大阪府")
  .set("兵庫県", "兵庫県")
  .set("奈良県", "奈良県")
  .set("和歌山県", "和歌山県")
  .set("鳥取県", "鳥取県")
  .set("島根県", "島根県")
  .set("岡山県", "岡山県")
  .set("広島県", "広島県")
  .set("山口県", "山口県")
  .set("徳島県", "徳島県")
  .set("香川県", "香川県")
  .set("愛媛県", "愛媛県")
  .set("高知県", "高知県")
  .set("福岡県", "福岡県")
  .set("佐賀県", "佐賀県")
  .set("長崎県", "長崎県")
  .set("熊本県", "熊本県")
  .set("大分県", "大分県")
  .set("宮崎県", "宮崎県")
  .set("鹿児島県", "鹿児島県")
  .set("沖縄県", "沖縄県");
